// extracted by mini-css-extract-plugin
export default {"placeholder":"Placeholder_placeholder__zirNR","placeholder-glow":"Placeholder_placeholder-glow__-EEz6"};